import { axiosProvider } from '@/app/core/axios';
import {
  ApiResponse,
  ListFilesTrackerResponseGatewayApiResponse,
  FileTrackerDetailResponseGatewayApiResponse,
} from '@ssar-app/domain';
import {
  FileTrackerListInput,
  FileTrackerMetrics,
} from '@ssar-app/file-tracker';
import { stringify } from 'qs';

export const getFilesList = (
  searchRequest: FileTrackerListInput,
): Promise<ApiResponse<ListFilesTrackerResponseGatewayApiResponse>> => {
  const qsConfig = {
    encodeValuesOnly: true,
    allowDots: true,
  };
  const query = stringify(searchRequest, qsConfig);
  return axiosProvider.apiClient
    .get<ApiResponse<ListFilesTrackerResponseGatewayApiResponse>>(
      `/file-tracker/list-files?${query}`,
    )
    .then((response) => {
      return response.data;
    });
};

export const getFileDetails = (
  fileId: string,
): Promise<ApiResponse<FileTrackerDetailResponseGatewayApiResponse>> => {
  return axiosProvider.apiClient
    .get<ApiResponse<FileTrackerDetailResponseGatewayApiResponse>>(
      `/file-tracker/file-details?TransferId=${fileId}`,
    )
    .then((response) => {
      return response.data;
    });
};

export const getMetrics = (
  searchRequest: FileTrackerListInput,
  monthValue?: number,
): Promise<ApiResponse<FileTrackerMetrics>> => {
  const qsConfig = {
    encodeValuesOnly: true,
    allowDots: true,
  };
  const query = stringify(searchRequest, qsConfig);
  return axiosProvider.apiClient
    .get<ApiResponse<FileTrackerMetrics>>(
      `/file-tracker/metrics?${query}&monthValue=${monthValue}`,
    )
    .then((response) => {
      return response.data;
    });
};
